
/**
 * Helper
 */
var helper = require('../../helper');

$(function() {

    $.fn.dataTable.moment( 'DD/MM/YYYY' );

    var $datatable = $('#datatable-tickets-of-client'),
            clientId = $datatable.data('client'),
        dataTables_buttons = [
	        {
		        extend: 'csv',
		        text: 'Export as CSV',
		        exportOptions: {
			        columns: [0, 1, 2, 3, 4, 5, 6, 7 ]
		        },
	        },
	        {
		        extend: 'pdf',
		        text: 'Export as PDF',
		        exportOptions: {
			        columns: [0, 1, 2, 3, 4, 5, 6, 7 ]
		        }
	        },
	        {
		        extend: 'print',
		        text: 'Print table',
		        exportOptions: {
			        columns: [0, 1, 2, 3, 4, 5, 6]
		        }
	        },
            {
                extend: 'colvis'
            }
        ];

    var table = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": {
            "url": helper.getOrigin() + "/api/tickets/clients/"+ clientId,
            "method": 'POST',
            "data": function ( d ) {
	            d.status_id = $('select[name=status_id]').val();
	            d.property_type = $('input[name=property_type]:checked').val();
	            d.date_type = $('select[name=date_type]').val();
	            d.date = $('input[name=date]').val();
	            d.date_to = $('input[name=date_to]').val();
            }
        },
        "autoWidth" : false,
        "buttons": dataTables_buttons,
        "displayLength": 10,
        "order": [[ 2, "desc" ]],
        "columns": [
            {data: 'ticketId', name: 'ticketId'},
            {data: 'status', name: 'statusName'},
            {data: 'property_name', name: 'propertyName'},
            {data: 'created_at', name: 'tickets.created_at'},
            {data: 'date_estimated_completion', name: 'tickets.date_estimated_completion'},
            {data: 'date_completed', name: 'tickets.date_completed'},
            {data: 'job_type', name: 'typeName'},
	        {data: 'cost_of_works', name: 'tickets.cost_of_works'},
	        {data: 'description', name: 'tickets.description', visible: false},
        ],
    });

	$('#search-form').on('submit', function(e) {
		table.draw();
		e.preventDefault();
	});

});
